import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { Search } from 'lucide-react'
import DropDownSearchMenu from 'components/layout/search/DropdownSearchMenu'
import SearchHelperContainer from 'redux/containers/components/layout/search/SearchHelperContainer'
import InfoHelperButtonContainer from 'redux/containers/components/layout/search/InfoHelperButtonContainer'

const SearchBox = ({
  currentSearchPhrase,
  displayName,
  searchTypeClasses,
  inputRef,
  hideNavigation,
  setCurrentSearchPhrase,
  pending
}) => {
  const [
    searchPhrase,
    setSearchPhrase
  ] = useState(currentSearchPhrase)

  useEffect(() => {
    setSearchPhrase(currentSearchPhrase)
  }, [currentSearchPhrase])

  const handleInputOnChange = (e) => {
    setSearchPhrase(e.target.value)
  }

  return (
    <div className='w-100 flex'>
      <div className='relative bg-ghost-grey mhauto w-100 flex justify-between'>
        <div className='items-stretch flex grow-1 h3 h2-m'>
          <DropDownSearchMenu inputRef={inputRef} {...{ searchTypeClasses }} />
          <div className='relative w0 grow-1 h-100'>
            <input
              placeholder={`Search ${displayName}`}
              onChange={handleInputOnChange}
              onFocus={() => hideNavigation()}
              ref={inputRef}
              className='placeholder-light-slate-grey bg-ghost-white w-100 h-100 pl6 pr8 ml0 ba b--transparent hover-b--slate-blue-grey focus-b--slate-blue-grey outline-0'
              value={searchPhrase}
              disabled={pending}
              id='search-input'
            />
            <InfoHelperButtonContainer {...{ inputRef }} />
          </div>
        </div>
        <button
          data-testid='search-submit-button'
          className={cx('white w9 w8-m pointer z10 flex justify-center items-center bg-black hover-bg-slate-blue-grey focus-bg-slate-blue-grey')}
        >
          <Search className='w6' />
        </button>
        <SearchHelperContainer />
      </div>
    </div>
  )
}

export default SearchBox
